(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["coupon-copy-button"] && !Shopify.designMode) return;
  try {
    (function () {
    function fallbackCopy(text) {
      var area = document.createElement('textarea');
      area.value = text;
      area.setAttribute('readonly', '');
      area.style.position = 'fixed';
      area.style.top = '-9999px';
      area.style.opacity = '0';
      document.body.appendChild(area);
      area.select();
      area.setSelectionRange(0, text.length);
      var ok = false;
      try {
        ok = document.execCommand('copy');
      } catch (e) {
        ok = false;
      }
      document.body.removeChild(area);
      return ok;
    }

    function copyText(text) {
      if (navigator.clipboard && window.isSecureContext) {
        return navigator.clipboard.writeText(text).then(
          function () { return true; },
          function () { return fallbackCopy(text); }
        );
      }
      return Promise.resolve(fallbackCopy(text));
    }

    document.addEventListener('click', function (event) {
      if (!(event.target instanceof Element)) return;

      var button = event.target.closest('[data-coupon-copy]');
      if (!button) return;

      event.preventDefault();

      var code = button.getAttribute('data-code') || '';
      if (!code) return;

      var wrapper = button.closest('.coupon-copy');
      var status = wrapper ? wrapper.querySelector('.coupon-copy__status') : null;
      var duration = parseInt(button.getAttribute('data-duration'), 10) || 2000;

      copyText(code).then(function (success) {
        if (!success) {
          if (status) status.textContent = 'Copy failed. Select the code and copy it manually.';
          return;
        }

        button.classList.add('is-copied');
        if (status) status.textContent = 'Coupon code ' + code + ' copied to clipboard.';

        clearTimeout(button._couponResetTimer);
        button._couponResetTimer = setTimeout(function () {
          button.classList.remove('is-copied');
          if (status) status.textContent = '';
        }, duration);
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
